import _ from 'lodash';
import * as ImagesConstants from '../../action/images/ImagesConstants';

const initialState = {
  allImagesDataIsFetching: false,
  allImagesData: [],
  allImagesDataErrorMessage: '',

  saveMultipleImagesStatus: {},
  saveMultipleImagesStatusIsFetching: false,
  saveMultipleImagesStatusErrorMessage: '',

  groupImagesWorkData: {},

  reservedIds: [],

  pendingIds: [],

  imageGroupCount: {},

  workingIds: []
};

export const imagesStore = (state = initialState, action) => {
  switch (action.type) {
    case ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_REQUEST:
      return {
        ...state,
        allImagesDataIsFetching: true,
        allImagesDataErrorMessage: ''
      };
    case ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_SUCCESS:
      let newAllImagesData = _.concat([], state.allImagesData, action.data);
      let newReservedIds = _.concat([], state.reservedIds, action.data);
      return {
        ...state,
        allImagesDataIsFetching: false,
        allImagesData: newAllImagesData,
        pendingIds: action.data,
        reservedIds: newReservedIds,
        allImagesDataErrorMessage: ''
      };
    case ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_FAILED:
      return {
        ...state,
        allImagesDataIsFetching: false,
        allImagesDataErrorMessage: 'SERVER ERROR'
      };
    case ImagesConstants.GET_ALL_IMAGES_FOR_PROCESSING_CLEAR:
      return {
        ...state,
        allImagesDataIsFetching: false,
        allImagesData: [],
        pendingIds: [],
        allImagesDataErrorMessage: ''
      };

    case ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_REQUEST:
      return {
        ...state,
        saveMultipleImagesStatusIsFetching: true,
        saveMultipleImagesStatusErrorMessage: ''
      };
    case ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_SUCCESS:
      return {
        ...state,
        saveMultipleImagesStatusIsFetching: false,
        saveMultipleImagesStatus: action.data
      };
    case ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_FAILED:
      return {
        ...state,
        saveMultipleImagesStatusIsFetching: false,
        saveMultipleImagesStatusErrorMessage: action.error.response.data
      };
    case ImagesConstants.SAVE_MULTIPLE_IMAGES_STATUS_CLEAR:
      return {
        ...state,
        saveMultipleImagesStatusIsFetching: false,
        saveMultipleImagesStatus: {},
        saveMultipleImagesStatusErrorMessage: ''
      };

    case ImagesConstants.CHANGE_GROUP_IMAGES_WORK_DATA:
      let newGroupImagesWorkData = _.cloneDeep(state.groupImagesWorkData);

      if (action.deleteIndex) {
        delete newGroupImagesWorkData[action.deleteIndex];
        newGroupImagesWorkData = _.merge(
          {},
          newGroupImagesWorkData,
          action.data
        );
      } else {
        newGroupImagesWorkData = _.merge(
          {},
          newGroupImagesWorkData,
          action.data
        );
      }

      return {
        ...state,
        groupImagesWorkData: newGroupImagesWorkData
      };

    case ImagesConstants.CHANGE_RESERVED_IDS_DATA:
      return {
        ...state,
        reservedIds: action.data
      };

    case ImagesConstants.SET_IMAGE_GROUP_COUNT:
      let newImageGroupCount = _.merge({}, state.imageGroupCount, {
        [action.groupIndex]: action.count
      });
      return {
        ...state,
        imageGroupCount: newImageGroupCount
      };

    case ImagesConstants.SET_IMAGE_WORKING_IDS:
      return {
        ...state,
        workingIds: action.workingIds
      };

    default:
      return state;
  }
};
